import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import QuoteImg from '../../../assets/images/quote.png';
import css from './TeamAbstract.module.css';
import TEST1 from './img/ts_1.png';
import TEST2 from './img/ts_2.png';
import TEST3 from './img/ts_3.png';
import TEST4 from './img/ts_4.png';


const TeamAbstract = ({isEasian}) => {

    const [currentSlide, setCurrentSlide] = useState(0);

    const nextSlide = () => {
        if(isEasian !== true)
        {
            setCurrentSlide((currentSlide + 1) % 2);
        }
        else{
      setCurrentSlide((currentSlide + 1) % 4);
        }
    };
  
    const prevSlide = () => {
        
        if(isEasian !== true)
            {
                setCurrentSlide((currentSlide + 3) % 2);
            }
            else{
      setCurrentSlide((currentSlide + 3) % 4);
            }
    };
  
    useEffect(() => {
      const interval = setInterval(() => {
        nextSlide();
      }, 10000); // Auto slide every 3 seconds
  
      return () => clearInterval(interval);
    }, [currentSlide]);
  

    return (
        <div>
            <h2 className={css.TestimonialHeading}><FormattedMessage id='TopbarDesktop.teamAbstractTitle' /></h2>
            <div className={css.bloclTestimoniaals}>
               
            {isEasian === true?
                <>
            <div className="slider1">

            <div className="slide1-container">
                <div className={currentSlide === 0 ? 'slide1 active' : 'slide1'}>
                    <div className={css.quoteImg}> <img src={QuoteImg} alt="quote" /></div>
                    <p><FormattedMessage id='TopbarDesktop.slideText6' /></p>
                    <div className={css.authorSec}>
                        <img src={TEST1}/>
                        <div className={css.imageSection}>
                        <span><b>Paul</b></span>
                        <span><FormattedMessage id='TopbarDesktop.slideSubText6' /></span>
                        </div>
                    </div>
                </div>
                <div className={currentSlide === 1 ? 'slide1 active' : 'slide1'}>
                <div className={css.quoteImg}> <img src={QuoteImg} alt="quote" /></div>
                    <p> <FormattedMessage id='TopbarDesktop.slideText2' /> </p>
                    <div className={css.authorSec}>
                        <img src={TEST2}/>
                        <div className={css.imageSection}>
                        <span><b>Mary Michelle</b></span>
                        <span><FormattedMessage id='TopbarDesktop.slideSubText2' /></span>
                        </div>
                    </div>
                </div>
                <div className={currentSlide === 2 ? 'slide1 active' : 'slide1'}>
                <div className={css.quoteImg}> <img src={QuoteImg} alt="quote" /></div>
                    <p>  <FormattedMessage id='TopbarDesktop.slideText5' /></p>
                    <div className={css.authorSec}>
                        <img src={TEST3}/>
                        <div className={css.imageSection}>
                        <span><b>Xing</b></span>
                        <span><FormattedMessage id='TopbarDesktop.slideSubText5' /></span>
                        </div>
                    </div>
                </div>
                </div>
                <div className={currentSlide === 3 ? 'slide1 active' : 'slide1'}>
                <div className={css.quoteImg}> <img src={QuoteImg} alt="quote" /></div>
                    <p>  <FormattedMessage id='TopbarDesktop.slideText4' /></p>
                    <div className={css.authorSec}>
                        <img src={TEST4}/>
                        <div className={css.imageSection}>
                        <span><b>Danielle</b></span>
                        <span><FormattedMessage id='TopbarDesktop.slideSubText4' /></span>
                        </div>
                    </div>
                </div>
            
                <div className={css.buttonControls}>
                    <button className="button1" onClick={prevSlide}>&#10094;</button>
                    <button className="button1" onClick={nextSlide}>&#10095;</button>
                </div>
                </div>
                </>:
                <div className="slider1">             

                <div className="slide1-container">
                    <div className={currentSlide === 0 ? 'slide1 active' : 'slide1'}>
                        <div className={css.quoteImg}> <img src={QuoteImg} alt="quote" /></div>
                        <p><FormattedMessage id='TopbarDesktop.slideText1' /></p>
                        <div className={css.authorSec}>
                            <img src={TEST1}/>
                            <div className={css.imageSection}>
                            <span><b>Gilles,</b></span>
                            <span><FormattedMessage id='TopbarDesktop.slideSubText1' /></span>
                            </div>
                        </div>
                    </div>
                    <div className={currentSlide === 1 ? 'slide1 active' : 'slide1'}>
                    <div className={css.quoteImg}> <img src={QuoteImg} alt="quote" /></div>
                        <p> <FormattedMessage id='TopbarDesktop.slideText3' /> </p>
                        <div className={css.authorSec}>
                            <img src={TEST2}/>
                            <div className={css.imageSection}>
                            <span><b>Dia,</b></span>
                            <span><FormattedMessage id='TopbarDesktop.slideSubText3' /></span>
                            </div>
                        </div>
                    </div>
                    </div>                   
                
                    <div className={css.buttonControls}>
                        <button className="button1" onClick={prevSlide}>&#10094;</button>
                        <button className="button1" onClick={nextSlide}>&#10095;</button>
                    </div>
                    </div>
                    }
             </div>
             <div>
                <button className={css.learnMore}><a href="https://world-like-home.community/t/etudiant-comment-avoir-une-famille-d-accueil-attestation-dhebergement-avec-world-like-home/5115" target='_blank' ><FormattedMessage id="TopbarDesktop.learnMore" /></a>
                </button>
             </div>
        </div>


        //<section className={css.TestimonialSection}>
        //    <div className={classNames(css.Container, css.ContainerXxl, css.TestimonialContainer)}>
        //        <h2 className={css.TestimonialHeading}><FormattedMessage id='TopbarDesktop.teamAbstractTitle' /></h2>
        //        <div className={css.Row}>
        //            <div className={css.ColLg12}>
        //                <div className={css.TestimonialSliderWrapper}>

        //                    <div className={css.TestimonialBox}>
        //                        <div className={css.TestimonialCard}>
        //                            <div className={css.TestimonialBody}>
        //                                <div className={css.TestimonialIcon}>
        //                                    <img src={QuoteImg} alt="quote" />
        //                                </div>
        //                                <p className={css.TestimonialText}>
        //                                    <FormattedMessage id='TopbarDesktop.teamAbstractFeed1' />
        //                                </p>
        //                                <div className={css.TestimonialAuthor}>
        //                                    <div className={css.TestimonialAuthorImage}>
        //                                        <img src="https://static.wixstatic.com/media/d910e3_d9cc4cf8f103429b928044a1751ce987~mv2.png/v1/fill/w_90,h_75,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/partner(1)_edited.png" alt="Paul" />
        //                                    </div>
        //                                    <div className={css.TestimonialAuthorDetails}>
        //                                        <p className={css.TestimonialAuthorName}>Paul</p>
        //                                        <p className={css.TestimonialAuthorLocation}>/ <FormattedMessage id='TopbarDesktop.teamAbstractFeedDesc' /></p>
        //                                    </div>
        //                                </div>
        //                            </div>
        //                        </div>
        //                    </div>
        //                </div>
        //            </div>
        //        </div>
        //    </div>
        //    <div className={classNames(css.Col12, css.TextCenter, css.TestimonialButton)}>
        //        <a href="https://world-like-home.community/t/avec-world-like-home-accueillir-un-etudiant-etranger-chez-soi-en-toute-tranquillite/4339" target="_blank" className={classNames(css.Btn, css.BtnLg, css.BtnDefault, css.TestimonialLink)}>
        //            <FormattedMessage id='ListingPage.learnMore' />
        //        </a>
        //    </div>
        //</section>
    );
};

export default TeamAbstract;
